export default __webpack_public_path__ + "static/916-2b4d650330214b9a5d12db79173641fb.gif";